import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';

import ContentArtesFacil from './ContentArtesFacil';

const ArtesFacil = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentArtesFacil baseUrl="/artes-prontas" />
      <Bottom />
    </div>
  );
};

export default ArtesFacil;
